import { RestockPullType } from "../Enums";
import IItemTrackingOptions from "../IItemTrackingOptions";
import Tenant from "./Tenant";

export default class Item implements IItemTrackingOptions {
  constructor(
    public id: number,
    public tenant: Tenant,
    public code: string,
    public name: string,
    public description: string,
    public baseUnitCode: string,
    public requiresLabel: boolean,
    public restockPullType: RestockPullType,
    public trackBestBeforeDate: boolean,
    public trackExpirationDate: boolean,
    public trackLotNumber: boolean,
    public bestBeforeLeadTime: number,
    public expirationLeadTime: number,
    public isInternalGenerated: boolean,
    public isBillable: boolean,
    public allowCalculatedLot: boolean
  ) {
  }
}
